__turbopack_context__.v({
  "onColor": "landing-button-module__W8uqtW__onColor",
  "primary": "landing-button-module__W8uqtW__primary",
  "tertiary": "landing-button-module__W8uqtW__tertiary",
});
